import { fieldGlob } from "./fields";
import { invoicesGlob } from "./invoices";

const rootArea = "/reports";

export const reportsGlob = () => ({
	self: rootArea,
	byId: (reportId: string) => ({ 	
		self: `${rootArea}/${reportId}`,		
		fields: fieldGlob(`${rootArea}/${reportId}`),
		invoices: invoicesGlob(`${rootArea}/${reportId}`)
	})
});
